import Vue from 'vue';
import App from './Index.vue';
import router from './router';
import store from './stores';

import injection from './lib/installer';
import '@/assets/less/global.less';

import moment from 'moment';

Vue.filter('dateFormat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    if (!isNaN(dataStr) && String(dataStr).length === 10) {
        dataStr = dataStr * 1000;
    }
    return moment(dataStr).format(pattern);
});

Vue.config.productionTip = false;
Vue.use(injection);
// store.commit('website', window._site);
injection.store = store;
injection.router = router;

injection.Vue = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});
